import {combineReducers} from 'redux';
import { connectRouter } from 'connected-react-router'
import {history} from "../utils/history";
import AuthReducer from "../../../common/js/auth/auth-reducer.jsx";
import DashboardReducer from "./dashboard-reducer";
import NotificationsReducer from "../../../common/js/notifications/notifications-reducer";
import ImportantDocumentsReducer from "./important-documents-reducer";
import LifeAtInnogyReducer from "./life-at-innogy-reducer";
import AssignmentsReducer from "./assignments-reducer";
import ConstantsReducer from "./constants-reducer";
import LangReducer from "./lang-reducer";

const allReducers = combineReducers({
    router: connectRouter(history),
    notifications: NotificationsReducer,
    auth: AuthReducer,
    dashboard: DashboardReducer,
    important_documents: ImportantDocumentsReducer,
    life_at_innogy: LifeAtInnogyReducer,
    assignments: AssignmentsReducer,
    constants: ConstantsReducer,
    lang: LangReducer
});

export default allReducers
